var $414c397f5e9f107e$exports = {};
$414c397f5e9f107e$exports = {
    "info": `Informacije`,
    "negative": `Pogre\u{161}ka`,
    "notice": `Upozorenje`,
    "positive": `Uspje\u{161}no`
};


export {$414c397f5e9f107e$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
